import store from "@/store"
import { jsonp } from "vue-jsonp"
import { Dialog } from "vant"

var change_city_by_location = function (lat, lng) {
  // lng = 106.45; lat = 29.56 // 重庆的

  var city_name = store.getters.city_name;
  budo_log.debug("#3 change_city_by_location", city_name, lat, lng)

  // 用户拒绝切换城市
  if (sessionStorage.getItem("budo.user_no_change_city")) {
    budo_log.info("#10 budo.user_no_change_city, return")
    return
  }

  // 未获取到经纬度
  if (!lat || !lng) {
    budo_log.debug("#16 change_city_by_location", city_name, lat, lng)
    return
  }

  // 经纬度转城市
  jsonp(`https://apis.map.qq.com/ws/geocoder/v1/`, {
    output: "jsonp",
    key: "VGZBZ-MACHK-DTQJB-ACE53-W2BZE-CKF3T",
    location: `${lat},${lng}`
  }).then(res => {
    budo_log.debug("#12 map geocoder", res);

    var city = res?.result?.ad_info?.city

    if (city && city_name != city) {
      // 还未快速切换过 快速切换一次 后面再切换就需确认了
      if (!sessionStorage.getItem("budo.user_change_city_confirm")) {
        budo_log.info("#36 geocoder SET_CITY_NAME", res)

        store.commit("SET_CITY_CODE", res?.result?.ad_info?.adcode.substring(0, 4))
        store.commit("SET_CITY_NAME", city)

        sessionStorage.setItem("budo.user_change_city_confirm", true) // 后面再切换就需确认了
        location.reload()
        return
      }

      Dialog.confirm({
        title: "切换城市",
        message: `定位到您在${city},是否切换?`
      }).then(() => {
        budo_log.info("#48 geocoder SET_CITY_NAME", res)

        store.commit("SET_CITY_CODE", res?.result?.ad_info?.adcode.substring(0, 4))
        store.commit("SET_CITY_NAME", city)
        location.reload()
      }).catch(() => {
        sessionStorage.setItem("budo.user_no_change_city", "true") // 用户拒绝切换城市 存在 sessionStorage 下次进来就没了
        location.reload()
      });
    }
  });
}

var isIos = function () {
  const u = navigator.userAgent;
  return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
}

var get_location_href = function () {
  if (isIos()) {
    return window['_location_href_'] || location.href
  }

  return location.href
}

export {
  change_city_by_location,
  get_location_href
}